<!-- HTML Template -->
<div class="details-container" [formGroup]="meetingForm">
  <!-- Top section with two columns -->
  <div class="top-section">
    <!-- Left column - Visible to invitees -->
    <div class="details-section-column">
      <h3>Visible to invitees</h3>
      
      <div class="form-field">
        <label>Meeting name</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput formControlName="meetingName" placeholder="Meeting">
          <mat-error *ngIf="f['meetingName'].hasError('required')">Meeting name is required</mat-error>
        </mat-form-field>
      </div>
      
      <div class="form-field">
        <label>Location</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput formControlName="meetingLocation" placeholder="Location">
        </mat-form-field>
      </div>
      
      <div class="form-field">
        <label>Video call</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select formControlName="videoCallOption">
            <mat-option value="no-video-call">No Video Call</mat-option>
            @if(hasGoogleMeet){
              <mat-option value="google-meet">Make it a Google Meet meeting</mat-option>
            }
            @if(hasZoomMeet){
              <mat-option value="zoom">Make it a Zoom meeting</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      
      <div class="form-field">
        <label>Description</label>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput formControlName="meetingDescription" rows="4" 
            placeholder="Additional information visible to invitees. For example description of event, etc."></textarea>
        </mat-form-field>
      </div>
      
      <div class="form-field">
        <label>Company name visible for the invitee</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput formControlName="companyName">
        </mat-form-field>
      </div>
    </div>
    
    <!-- Right column - Activity section -->
    <div class="activity-section-column">
      <p>Save meeting to DostifyCRM calendar as</p>
      <mat-button-toggle-group
        formControlName="type_id"
        name="eventType"
        aria-label="Event type selection"
        class="type-field"
      >
        @for(activity of activityTypes; track activity.id){
          <mat-button-toggle [value]="activity.id" [matTooltip]="activity?.name">
            <mat-icon>{{ activity.icon }}</mat-icon>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
      
      <div class="notes">
        <app-html-editor 
          [formControl]="$any(meetingForm).get('activityNote')"
          [height]="'100px'"
          [showNoteBackground]="true"
          placeholder="Notes"
          [quillModule]="quillModule"
          title="Notes"
        ></app-html-editor>
      </div>
    </div>
  </div>
  
  <!-- Full width sections -->
  <div class="full-width-sections">
    <!-- Meeting Type Toggle -->
    <div class="details-section" *ngIf="isAvailibility()">
      <h3>Meeting Type</h3>
      <div class="meeting-type-toggle">
        <mat-button-toggle-group formControlName="createLeadMode" aria-label="Meeting Type">
          <mat-button-toggle value="meeting-only">Create Meeting Only</mat-button-toggle>
          <mat-button-toggle value="lead-and-meeting">Create Lead and Meeting</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    
    <!-- Fields Section -->
    <div class="details-section">
      <h3>Fields for the invitee to fill in</h3>
      
      <div class="checkbox-field" *ngIf="meetingForm.get('createLeadMode')?.value === 'meeting-only'">
        <mat-checkbox formControlName="prefillNameEmail">Prefill name and email</mat-checkbox>
      </div>
      
      <!-- All fields (default and custom) in a single section -->
      <div formArrayName="fields">
        <!-- Default Fields Section - Only shown when createLeadMode is 'meeting-only' -->
        <div class="default-fields-section" *ngIf="meetingForm.get('createLeadMode')?.value === 'meeting-only'">
          <div class="drag-drop-container" 
               cdkDropList 
               [cdkDropListData]="getDefaultFields()"
               (cdkDropListDropped)="onFieldDrop($event, 'default')">
            
            <div *ngFor="let field of getDefaultFields(); let i = index" 
                 class="field-item draggable-field" 
                 [formGroupName]="fields.controls.indexOf(field)"
                 [ngClass]="{'disabled-field': !field.get('isRequired')?.value}"
                 cdkDrag>
              
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              
              <div class="field-content">
                <div class="field-header">
                  <div class="field-with-checkbox">
                    <span>{{ field.get('fieldName')?.value }}</span>
                    <mat-checkbox formControlName="isRequired" color="primary">Required</mat-checkbox>
                  </div>
                </div>
                
                <!-- Prefill input for this field -->
                <div *ngIf="field.get('showPrefill')?.value" class="field-prefill">
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="prefillValue" [placeholder]="'Default ' + field.get('fieldName')?.value.toLowerCase()">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Lead Fields Section (Only shown when createLeadMode is 'lead-and-meeting') -->
        <div class="lead-fields-section" *ngIf="meetingForm.get('createLeadMode')?.value === 'lead-and-meeting'">
          <h4>Lead fields ({{ getLeadFields().length }} fields)</h4>
          
          <!-- Debug info -->
          <div *ngIf="getLeadFields().length === 0 && fields.length > 0" class="debug-info">
            <small>Debug: {{ fields.length }} total fields, but 0 lead fields found</small>
          </div>
          
          <div class="drag-drop-container" 
               cdkDropList 
               [cdkDropListData]="getLeadFields()"
               (cdkDropListDropped)="onFieldDrop($event, 'lead')">
            
            <div *ngFor="let field of getLeadFields(); let i = index" 
                 class="lead-field-item draggable-field" 
                 [formGroupName]="fields.controls.indexOf(field)"
                 cdkDrag>
              
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              
              <div class="field-content">
                <div class="field-header">
                  <div class="field-with-checkbox">
                    <span>{{ field.get('fieldName')?.value }} ({{ field.get('key')?.value }})</span>
                    <div class="field-options">
                      <!-- Required checkbox - disabled when showInScheduler is false -->
                      <mat-checkbox 
                        formControlName="isRequired" 
                        color="primary"
                        [disabled]="!field.get('showInScheduler')?.value"
                        [class.disabled-checkbox]="!field.get('showInScheduler')?.value">
                        Required
                      </mat-checkbox>
                      
                      <!-- Show in scheduler checkbox -->
                      <mat-checkbox 
                        formControlName="showInScheduler" 
                        color="primary">
                        Show in scheduler
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Show message if no fields -->
            <div *ngIf="getLeadFields().length === 0" class="no-fields-message">
              <p>No lead fields available</p>
            </div>
          </div>
        </div>
        
        <!-- Custom Fields Section -->
        <div class="custom-fields-section" *ngIf="meetingForm.get('createLeadMode')?.value === 'meeting-only'">
          <h4>Custom fields</h4>
          <div class="drag-drop-container" 
               cdkDropList 
               [cdkDropListData]="getCustomFields()"
               (cdkDropListDropped)="onFieldDrop($event, 'custom')">
            
            <div *ngFor="let field of getCustomFields(); let i = index" 
                 class="custom-field-item draggable-field" 
                 [formGroupName]="fields.controls.indexOf(field)"
                 [ngClass]="{'new-field': field.get('isNew')?.value}"
                 cdkDrag>
              
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              
              <div class="field-content">
                <div class="form-field custom-field-container">
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="fieldName" placeholder="Field name">
                    <mat-error *ngIf="field.get('fieldName')?.hasError('required')">Field name is required</mat-error>
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="fieldType" placeholder="Field type">
                      <mat-option *ngFor="let type of fieldTypes" [value]="type.value">
                        {{type.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline" *ngIf="field.get('fieldType')?.value === 'select'">
                    <input matInput formControlName="options" placeholder="Options (comma separated)">
                    <mat-hint>Separate options with commas</mat-hint>
                  </mat-form-field>
                  
                  <div class="field-actions">
                    <mat-checkbox formControlName="isRequired" color="primary">Required</mat-checkbox>
                    <button mat-icon-button color="warn" type="button" (click)="removeField(fields.controls.indexOf(field))">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <button mat-button color="primary" class="add-field-button" type="button" (click)="addNewCustomField()">
            <mat-icon>add</mat-icon> Add field
          </button>
        </div>
      </div>
    </div>
    
    <!-- Source Selection Section -->
    <div class="details-section" *ngIf="meetingForm.get('createLeadMode')?.value === 'lead-and-meeting'">
      <h3>Source</h3>
      <div class="form-field">
        <label>Lead source (optional)</label>
        <div class="source-select-container">
          <app-select
            formControlName="sourceId"
            [formControl]="$any(meetingForm).get('sourceId')"
            [placeholder]="'Select source (defaults to Meeting Scheduler)'"
            [options]="sources"
            [multiple]="false"
            [hideSubscript]="true"
            (selectionChange)="onSourceChange($event)"
          ></app-select>
        </div>
        <mat-hint class="source-hint">
          <mat-icon class="info-icon">info</mat-icon>
          If no source is selected, it will default to "Meeting Scheduler"
        </mat-hint>
      </div>
    </div>
    
    <!-- Footer Text Section -->
    <div class="details-section">
      <div class="form-field">
        <label>Footer text</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput formControlName="footerText">
        </mat-form-field>
      </div>
    </div>
  </div>
</div>